import { createReducer } from '@common/redux-utils';
import { SwoPayoutViewModel } from '@models/SwoPayout';

import {
  ApproveCilOfferFailure,
  ApproveCilOfferStart,
  ApproveCilOfferSuccess,
  CilOfferActionType,
  DeleteCilOfferFailure,
  DeleteCilOfferStart,
  DeleteCilOfferSuccess,
  SearchCilOffersFailureAction,
  SearchCilOffersStartAction,
  SearchCilOffersSuccessAction
} from './cil-offer.actions';

// Defining the state of the page.
// Should be one per page.
// All properties should be readonly.
export interface CilOfferState {
  readonly message?: string;
  readonly searchLoading: boolean;
  readonly searchOrderBy: string;
  readonly searchOrderByDirection: 'asc' | 'desc';
  readonly searchPageCount: number;
  readonly searchPageNumber: number;
  readonly searchPageSize: number;
  readonly searchQuery: string | null;
  readonly searchResults: SwoPayoutViewModel[];
  readonly searchResultsTotalCount: number;
}

// This is the initial state of the page
const initialState: CilOfferState = {
  message: 'Initialized',
  searchLoading: false,
  searchOrderBy: 'swoid',
  searchOrderByDirection: 'asc',
  searchPageCount: 0,
  searchPageNumber: 1,
  searchPageSize: 10,
  searchQuery: null,
  searchResults: [],
  searchResultsTotalCount: 0
};

/********** Approve **********/
function handleApproveCilOfferFailure(state: CilOfferState, action: ApproveCilOfferFailure): CilOfferState {
  return {
    ...state,
    searchLoading: false
  };
}
function handleApproveCilOfferStart(state: CilOfferState, action: ApproveCilOfferStart): CilOfferState {
  return {
    ...state,
    searchLoading: true
  };
}
function handleApproveCilOfferSuccess(state: CilOfferState, action: ApproveCilOfferSuccess): CilOfferState {
  return {
    ...state
  };
}

/********** Delete **********/
function handleDeleteCilOfferFailure(state: CilOfferState, action: DeleteCilOfferFailure): CilOfferState {
  return {
    ...state,
    searchLoading: false
  };
}
function handleDeleteCilOfferStart(state: CilOfferState, action: DeleteCilOfferStart): CilOfferState {
  return {
    ...state,
    searchLoading: true
  };
}
function handleDeleteCilOfferSuccess(state: CilOfferState, action: DeleteCilOfferSuccess): CilOfferState {
  return {
    ...state
  };
}

/********** Search **********/
function handleSearchCilOffersFailure(state: CilOfferState, action: SearchCilOffersFailureAction): CilOfferState {
  return {
    ...state,
    message: action.errorMessage,
    searchLoading: false
  };
}
function handleSearchCilOffersStart(state: CilOfferState, action: SearchCilOffersStartAction): CilOfferState {
  return {
    ...state,
    message: 'Search Init!',
    searchLoading: true,
    searchOrderBy: action.orderBy,
    searchOrderByDirection: action.orderByDirection,
    searchPageNumber: action.pageNumber,
    searchPageSize: action.pageSize,
    searchQuery: action.query
  };
}
function handleSearchCilOffersSuccess(state: CilOfferState, action: SearchCilOffersSuccessAction): CilOfferState {
  return {
    ...state,
    message: 'Search Success!',
    searchLoading: false,
    searchPageCount: Math.ceil(action.searchResult.totalResults / action.searchResult.pageSize),
    searchResults: action.searchResult.results,
    searchResultsTotalCount: action.searchResult.totalResults
  };
}

// This creates the reducer as redux wants it w/ a helper function
// There should an entry for each action type
export const CilOfferReducer = createReducer(initialState, {
  /********** Approve **********/
  [CilOfferActionType.ApproveCilOfferFailure]: handleApproveCilOfferFailure,
  [CilOfferActionType.ApproveCilOfferStart]: handleApproveCilOfferStart,
  [CilOfferActionType.ApproveCilOfferSuccess]: handleApproveCilOfferSuccess,
  /********** Delete **********/
  [CilOfferActionType.DeleteCilOfferFailure]: handleDeleteCilOfferFailure,
  [CilOfferActionType.DeleteCilOfferStart]: handleDeleteCilOfferStart,
  [CilOfferActionType.DeleteCilOfferSuccess]: handleDeleteCilOfferSuccess,
  /********** Search **********/
  [CilOfferActionType.SearchCilOffersFailure]: handleSearchCilOffersFailure,
  [CilOfferActionType.SearchCilOffersStart]: handleSearchCilOffersStart,
  [CilOfferActionType.SearchCilOffersSuccess]: handleSearchCilOffersSuccess
});



// WEBPACK FOOTER //
// ./src/cil-offer/cil-offer.reducer.ts